export var getDescendantByParent = function (nodes, currentContainer) {
    var foundList = [];
    var search = function (currentParent) {
        nodes.forEach(function (n) {
            if (!foundList.includes(n.id) && n.parentId === currentParent && n.id !== currentParent) {
                foundList.push(n.id);
                search(n.id);
            }
        });
    };
    search(currentContainer.id);
    return nodes.filter(function (n) { return foundList.includes(n.id); });
};
export var getAllDescendantsForCurrentContainers = function (nodeList, containerItems) {
    return containerItems.map(function (parent) {
        return getDescendantByParent(nodeList, parent);
    });
};
export var getChildrenByParent = function (nodes, parentId) {
    if (parentId === void 0) { parentId = null; }
    return nodes.filter(function (n) { return n.parentId === parentId; });
};
//# sourceMappingURL=NodeList.js.map